// source: broker-manager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.brokermanager.AddBrokerReply', null, global);
goog.exportSymbol('proto.brokermanager.AddBrokerReq', null, global);
goog.exportSymbol('proto.brokermanager.AddServerReply', null, global);
goog.exportSymbol('proto.brokermanager.AddServerReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminAddServerIPReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminAddServerIPReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminDeleteServerIPReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminDeleteServerIPReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminGetServerIPsReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminGetServerIPsReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminGetServersInfoReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminGetServersInfoReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminPingHostManyReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminPingHostManyReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminReorderServerIPsReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminReorderServerIPsReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminUpdateServerIPReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminUpdateServerIPReq', null, global);
goog.exportSymbol('proto.brokermanager.AdminUpdateServerReply', null, global);
goog.exportSymbol('proto.brokermanager.AdminUpdateServerReq', null, global);
goog.exportSymbol('proto.brokermanager.BrokerInfo', null, global);
goog.exportSymbol('proto.brokermanager.Company', null, global);
goog.exportSymbol('proto.brokermanager.ConnectionType', null, global);
goog.exportSymbol('proto.brokermanager.DeleteBrokerReply', null, global);
goog.exportSymbol('proto.brokermanager.DeleteBrokerReq', null, global);
goog.exportSymbol('proto.brokermanager.DeleteServerReply', null, global);
goog.exportSymbol('proto.brokermanager.DeleteServerReq', null, global);
goog.exportSymbol('proto.brokermanager.GetBrokerInfoReply', null, global);
goog.exportSymbol('proto.brokermanager.GetBrokerInfoReq', null, global);
goog.exportSymbol('proto.brokermanager.GetServerInfoManyReply', null, global);
goog.exportSymbol('proto.brokermanager.GetServerInfoManyReq', null, global);
goog.exportSymbol('proto.brokermanager.GetServerInfoReply', null, global);
goog.exportSymbol('proto.brokermanager.GetServerInfoReq', null, global);
goog.exportSymbol('proto.brokermanager.IntBrokerServerInfoReply', null, global);
goog.exportSymbol('proto.brokermanager.IntBrokerServerInfoReq', null, global);
goog.exportSymbol('proto.brokermanager.IntBrokerServersIPMapInfoReply', null, global);
goog.exportSymbol('proto.brokermanager.IntBrokerServersIPMapInfoReq', null, global);
goog.exportSymbol('proto.brokermanager.IntGetBrokerInfoByNameReply', null, global);
goog.exportSymbol('proto.brokermanager.IntGetBrokerInfoByNameReq', null, global);
goog.exportSymbol('proto.brokermanager.IntGetServersBaseSymbolsReply', null, global);
goog.exportSymbol('proto.brokermanager.IntGetServersBaseSymbolsReq', null, global);
goog.exportSymbol('proto.brokermanager.ListBrokerReply', null, global);
goog.exportSymbol('proto.brokermanager.ListBrokersReq', null, global);
goog.exportSymbol('proto.brokermanager.OperatingMode', null, global);
goog.exportSymbol('proto.brokermanager.PingHostMany', null, global);
goog.exportSymbol('proto.brokermanager.PingHostReply', null, global);
goog.exportSymbol('proto.brokermanager.SearchBrokerRely', null, global);
goog.exportSymbol('proto.brokermanager.SearchBrokerReq', null, global);
goog.exportSymbol('proto.brokermanager.Server', null, global);
goog.exportSymbol('proto.brokermanager.ServerBaseSymbol', null, global);
goog.exportSymbol('proto.brokermanager.ServerIP', null, global);
goog.exportSymbol('proto.brokermanager.ServerIPOrder', null, global);
goog.exportSymbol('proto.brokermanager.ServerInfo', null, global);
goog.exportSymbol('proto.brokermanager.ServerRes', null, global);
goog.exportSymbol('proto.brokermanager.ServerWithBroker', null, global);
goog.exportSymbol('proto.brokermanager.UpdateBrokerReply', null, global);
goog.exportSymbol('proto.brokermanager.UpdateBrokerReq', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.displayName = 'proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.displayName = 'proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.displayName = 'proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.displayName = 'proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.IntGetServersBaseSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.IntGetServersBaseSymbolsReq.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.IntGetServersBaseSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.IntGetServersBaseSymbolsReq.displayName = 'proto.brokermanager.IntGetServersBaseSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.ServerBaseSymbol = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.ServerBaseSymbol, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.ServerBaseSymbol.displayName = 'proto.brokermanager.ServerBaseSymbol';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.IntGetServersBaseSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.IntGetServersBaseSymbolsReply.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.IntGetServersBaseSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.IntGetServersBaseSymbolsReply.displayName = 'proto.brokermanager.IntGetServersBaseSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminUpdateServerIPReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminUpdateServerIPReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminUpdateServerIPReq.displayName = 'proto.brokermanager.AdminUpdateServerIPReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminUpdateServerIPReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminUpdateServerIPReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminUpdateServerIPReply.displayName = 'proto.brokermanager.AdminUpdateServerIPReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.PingHostReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.PingHostReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.PingHostReply.displayName = 'proto.brokermanager.PingHostReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.PingHostMany = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.PingHostMany, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.PingHostMany.displayName = 'proto.brokermanager.PingHostMany';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminPingHostManyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.AdminPingHostManyReq.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.AdminPingHostManyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminPingHostManyReq.displayName = 'proto.brokermanager.AdminPingHostManyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminPingHostManyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.AdminPingHostManyReply.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.AdminPingHostManyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminPingHostManyReply.displayName = 'proto.brokermanager.AdminPingHostManyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.IntGetBrokerInfoByNameReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.IntGetBrokerInfoByNameReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.IntGetBrokerInfoByNameReq.displayName = 'proto.brokermanager.IntGetBrokerInfoByNameReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.IntGetBrokerInfoByNameReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.IntGetBrokerInfoByNameReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.IntGetBrokerInfoByNameReply.displayName = 'proto.brokermanager.IntGetBrokerInfoByNameReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminGetServersInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.AdminGetServersInfoReq.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.AdminGetServersInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminGetServersInfoReq.displayName = 'proto.brokermanager.AdminGetServersInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminGetServersInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminGetServersInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminGetServersInfoReply.displayName = 'proto.brokermanager.AdminGetServersInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.ListBrokersReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.ListBrokersReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.ListBrokersReq.displayName = 'proto.brokermanager.ListBrokersReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.ListBrokerReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.ListBrokerReply.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.ListBrokerReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.ListBrokerReply.displayName = 'proto.brokermanager.ListBrokerReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.BrokerInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.BrokerInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.BrokerInfo.displayName = 'proto.brokermanager.BrokerInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.GetBrokerInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.GetBrokerInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.GetBrokerInfoReq.displayName = 'proto.brokermanager.GetBrokerInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.GetBrokerInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.GetBrokerInfoReply.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.GetBrokerInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.GetBrokerInfoReply.displayName = 'proto.brokermanager.GetBrokerInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.Server = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.Server, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.Server.displayName = 'proto.brokermanager.Server';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.ServerWithBroker = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.ServerWithBroker, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.ServerWithBroker.displayName = 'proto.brokermanager.ServerWithBroker';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AddBrokerReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AddBrokerReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AddBrokerReq.displayName = 'proto.brokermanager.AddBrokerReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AddBrokerReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AddBrokerReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AddBrokerReply.displayName = 'proto.brokermanager.AddBrokerReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.UpdateBrokerReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.UpdateBrokerReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.UpdateBrokerReq.displayName = 'proto.brokermanager.UpdateBrokerReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.UpdateBrokerReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.UpdateBrokerReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.UpdateBrokerReply.displayName = 'proto.brokermanager.UpdateBrokerReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.DeleteBrokerReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.DeleteBrokerReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.DeleteBrokerReq.displayName = 'proto.brokermanager.DeleteBrokerReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.DeleteBrokerReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.DeleteBrokerReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.DeleteBrokerReply.displayName = 'proto.brokermanager.DeleteBrokerReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AddServerReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AddServerReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AddServerReq.displayName = 'proto.brokermanager.AddServerReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AddServerReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AddServerReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AddServerReply.displayName = 'proto.brokermanager.AddServerReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminUpdateServerReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminUpdateServerReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminUpdateServerReq.displayName = 'proto.brokermanager.AdminUpdateServerReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminUpdateServerReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminUpdateServerReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminUpdateServerReply.displayName = 'proto.brokermanager.AdminUpdateServerReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.DeleteServerReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.DeleteServerReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.DeleteServerReq.displayName = 'proto.brokermanager.DeleteServerReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.DeleteServerReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.DeleteServerReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.DeleteServerReply.displayName = 'proto.brokermanager.DeleteServerReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.GetServerInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.GetServerInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.GetServerInfoReq.displayName = 'proto.brokermanager.GetServerInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.GetServerInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.GetServerInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.GetServerInfoReply.displayName = 'proto.brokermanager.GetServerInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.SearchBrokerReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.SearchBrokerReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.SearchBrokerReq.displayName = 'proto.brokermanager.SearchBrokerReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.SearchBrokerRely = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.SearchBrokerRely.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.SearchBrokerRely, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.SearchBrokerRely.displayName = 'proto.brokermanager.SearchBrokerRely';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.Company = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.Company.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.Company, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.Company.displayName = 'proto.brokermanager.Company';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.ServerRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.ServerRes.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.ServerRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.ServerRes.displayName = 'proto.brokermanager.ServerRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.GetServerInfoManyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.GetServerInfoManyReq.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.GetServerInfoManyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.GetServerInfoManyReq.displayName = 'proto.brokermanager.GetServerInfoManyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.GetServerInfoManyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.GetServerInfoManyReply.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.GetServerInfoManyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.GetServerInfoManyReply.displayName = 'proto.brokermanager.GetServerInfoManyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.IntBrokerServerInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.IntBrokerServerInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.IntBrokerServerInfoReq.displayName = 'proto.brokermanager.IntBrokerServerInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.IntBrokerServerInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.IntBrokerServerInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.IntBrokerServerInfoReply.displayName = 'proto.brokermanager.IntBrokerServerInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.IntBrokerServersIPMapInfoReq.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.IntBrokerServersIPMapInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.IntBrokerServersIPMapInfoReq.displayName = 'proto.brokermanager.IntBrokerServersIPMapInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.IntBrokerServersIPMapInfoReply.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.IntBrokerServersIPMapInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.IntBrokerServersIPMapInfoReply.displayName = 'proto.brokermanager.IntBrokerServersIPMapInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.ServerInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.ServerInfo.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.ServerInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.ServerInfo.displayName = 'proto.brokermanager.ServerInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminAddServerIPReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminAddServerIPReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminAddServerIPReq.displayName = 'proto.brokermanager.AdminAddServerIPReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminAddServerIPReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminAddServerIPReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminAddServerIPReply.displayName = 'proto.brokermanager.AdminAddServerIPReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminReorderServerIPsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.AdminReorderServerIPsReq.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.AdminReorderServerIPsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminReorderServerIPsReq.displayName = 'proto.brokermanager.AdminReorderServerIPsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.ServerIPOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.ServerIPOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.ServerIPOrder.displayName = 'proto.brokermanager.ServerIPOrder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminReorderServerIPsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminReorderServerIPsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminReorderServerIPsReply.displayName = 'proto.brokermanager.AdminReorderServerIPsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminGetServerIPsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminGetServerIPsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminGetServerIPsReq.displayName = 'proto.brokermanager.AdminGetServerIPsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminGetServerIPsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.brokermanager.AdminGetServerIPsReply.repeatedFields_, null);
};
goog.inherits(proto.brokermanager.AdminGetServerIPsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminGetServerIPsReply.displayName = 'proto.brokermanager.AdminGetServerIPsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.ServerIP = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.ServerIP, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.ServerIP.displayName = 'proto.brokermanager.ServerIP';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminDeleteServerIPReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminDeleteServerIPReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminDeleteServerIPReq.displayName = 'proto.brokermanager.AdminDeleteServerIPReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.brokermanager.AdminDeleteServerIPReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.brokermanager.AdminDeleteServerIPReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.brokermanager.AdminDeleteServerIPReply.displayName = 'proto.brokermanager.AdminDeleteServerIPReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
connectionType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq;
  return proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 2:
      var value = /** @type {!proto.brokermanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string server_id = 1;
 * @return {string}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq} returns this
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ConnectionType connection_type = 2;
 * @return {!proto.brokermanager.ConnectionType}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.prototype.getConnectionType = function() {
  return /** @type {!proto.brokermanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.brokermanager.ConnectionType} value
 * @return {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq} returns this
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReq.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply;
  return proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminChangeServerAccountsConnectionTypeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
connectionType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq;
  return proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 2:
      var value = /** @type {!proto.brokermanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string broker_id = 1;
 * @return {string}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq} returns this
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ConnectionType connection_type = 2;
 * @return {!proto.brokermanager.ConnectionType}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.prototype.getConnectionType = function() {
  return /** @type {!proto.brokermanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.brokermanager.ConnectionType} value
 * @return {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq} returns this
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReq.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply;
  return proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminChangeBrokerAccountsConnectionTypeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.IntGetServersBaseSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.IntGetServersBaseSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.IntGetServersBaseSymbolsReq}
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.IntGetServersBaseSymbolsReq;
  return proto.brokermanager.IntGetServersBaseSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.IntGetServersBaseSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.IntGetServersBaseSymbolsReq}
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addServerIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.IntGetServersBaseSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.IntGetServersBaseSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string server_ids = 1;
 * @return {!Array<string>}
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.prototype.getServerIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.brokermanager.IntGetServersBaseSymbolsReq} returns this
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.prototype.setServerIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.IntGetServersBaseSymbolsReq} returns this
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.prototype.addServerIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.IntGetServersBaseSymbolsReq} returns this
 */
proto.brokermanager.IntGetServersBaseSymbolsReq.prototype.clearServerIdsList = function() {
  return this.setServerIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.ServerBaseSymbol.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.ServerBaseSymbol.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.ServerBaseSymbol} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerBaseSymbol.toObject = function(includeInstance, msg) {
  var f, obj = {
serverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
baseSymbol: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.ServerBaseSymbol}
 */
proto.brokermanager.ServerBaseSymbol.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.ServerBaseSymbol;
  return proto.brokermanager.ServerBaseSymbol.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.ServerBaseSymbol} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.ServerBaseSymbol}
 */
proto.brokermanager.ServerBaseSymbol.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.ServerBaseSymbol.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.ServerBaseSymbol.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.ServerBaseSymbol} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerBaseSymbol.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBaseSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string server_id = 1;
 * @return {string}
 */
proto.brokermanager.ServerBaseSymbol.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerBaseSymbol} returns this
 */
proto.brokermanager.ServerBaseSymbol.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string base_symbol = 2;
 * @return {string}
 */
proto.brokermanager.ServerBaseSymbol.prototype.getBaseSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerBaseSymbol} returns this
 */
proto.brokermanager.ServerBaseSymbol.prototype.setBaseSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.IntGetServersBaseSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.IntGetServersBaseSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
serverBaseSymbolsList: jspb.Message.toObjectList(msg.getServerBaseSymbolsList(),
    proto.brokermanager.ServerBaseSymbol.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.IntGetServersBaseSymbolsReply}
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.IntGetServersBaseSymbolsReply;
  return proto.brokermanager.IntGetServersBaseSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.IntGetServersBaseSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.IntGetServersBaseSymbolsReply}
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.brokermanager.ServerBaseSymbol;
      reader.readMessage(value,proto.brokermanager.ServerBaseSymbol.deserializeBinaryFromReader);
      msg.addServerBaseSymbols(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.IntGetServersBaseSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.IntGetServersBaseSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerBaseSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.brokermanager.ServerBaseSymbol.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ServerBaseSymbol server_base_symbols = 1;
 * @return {!Array<!proto.brokermanager.ServerBaseSymbol>}
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.prototype.getServerBaseSymbolsList = function() {
  return /** @type{!Array<!proto.brokermanager.ServerBaseSymbol>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.ServerBaseSymbol, 1));
};


/**
 * @param {!Array<!proto.brokermanager.ServerBaseSymbol>} value
 * @return {!proto.brokermanager.IntGetServersBaseSymbolsReply} returns this
*/
proto.brokermanager.IntGetServersBaseSymbolsReply.prototype.setServerBaseSymbolsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.brokermanager.ServerBaseSymbol=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.ServerBaseSymbol}
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.prototype.addServerBaseSymbols = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.brokermanager.ServerBaseSymbol, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.IntGetServersBaseSymbolsReply} returns this
 */
proto.brokermanager.IntGetServersBaseSymbolsReply.prototype.clearServerBaseSymbolsList = function() {
  return this.setServerBaseSymbolsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminUpdateServerIPReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminUpdateServerIPReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminUpdateServerIPReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
address: (f = msg.getAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
port: (f = msg.getPort()) && google_protobuf_wrappers_pb.UInt64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminUpdateServerIPReq}
 */
proto.brokermanager.AdminUpdateServerIPReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminUpdateServerIPReq;
  return proto.brokermanager.AdminUpdateServerIPReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminUpdateServerIPReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminUpdateServerIPReq}
 */
proto.brokermanager.AdminUpdateServerIPReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.UInt64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt64Value.deserializeBinaryFromReader);
      msg.setPort(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminUpdateServerIPReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminUpdateServerIPReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminUpdateServerIPReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPort();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.UInt64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string server_id = 1;
 * @return {string}
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminUpdateServerIPReq} returns this
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue address = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.getAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.AdminUpdateServerIPReq} returns this
*/
proto.brokermanager.AdminUpdateServerIPReq.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AdminUpdateServerIPReq} returns this
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.UInt64Value port = 3;
 * @return {?proto.google.protobuf.UInt64Value}
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.getPort = function() {
  return /** @type{?proto.google.protobuf.UInt64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt64Value, 3));
};


/**
 * @param {?proto.google.protobuf.UInt64Value|undefined} value
 * @return {!proto.brokermanager.AdminUpdateServerIPReq} returns this
*/
proto.brokermanager.AdminUpdateServerIPReq.prototype.setPort = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AdminUpdateServerIPReq} returns this
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.clearPort = function() {
  return this.setPort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AdminUpdateServerIPReq.prototype.hasPort = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminUpdateServerIPReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminUpdateServerIPReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminUpdateServerIPReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminUpdateServerIPReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminUpdateServerIPReply}
 */
proto.brokermanager.AdminUpdateServerIPReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminUpdateServerIPReply;
  return proto.brokermanager.AdminUpdateServerIPReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminUpdateServerIPReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminUpdateServerIPReply}
 */
proto.brokermanager.AdminUpdateServerIPReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminUpdateServerIPReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminUpdateServerIPReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminUpdateServerIPReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminUpdateServerIPReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.PingHostReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.PingHostReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.PingHostReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.PingHostReply.toObject = function(includeInstance, msg) {
  var f, obj = {
host: jspb.Message.getFieldWithDefault(msg, 1, ""),
port: jspb.Message.getFieldWithDefault(msg, 2, 0),
delay: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
error: (f = msg.getError()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.PingHostReply}
 */
proto.brokermanager.PingHostReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.PingHostReply;
  return proto.brokermanager.PingHostReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.PingHostReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.PingHostReply}
 */
proto.brokermanager.PingHostReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPort(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDelay(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.PingHostReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.PingHostReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.PingHostReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.PingHostReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDelay();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string host = 1;
 * @return {string}
 */
proto.brokermanager.PingHostReply.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.PingHostReply} returns this
 */
proto.brokermanager.PingHostReply.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 port = 2;
 * @return {number}
 */
proto.brokermanager.PingHostReply.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.PingHostReply} returns this
 */
proto.brokermanager.PingHostReply.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double delay = 3;
 * @return {number}
 */
proto.brokermanager.PingHostReply.prototype.getDelay = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.PingHostReply} returns this
 */
proto.brokermanager.PingHostReply.prototype.setDelay = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue error = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.PingHostReply.prototype.getError = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.PingHostReply} returns this
*/
proto.brokermanager.PingHostReply.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.PingHostReply} returns this
 */
proto.brokermanager.PingHostReply.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.PingHostReply.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.PingHostMany.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.PingHostMany.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.PingHostMany} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.PingHostMany.toObject = function(includeInstance, msg) {
  var f, obj = {
host: jspb.Message.getFieldWithDefault(msg, 1, ""),
port: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.PingHostMany}
 */
proto.brokermanager.PingHostMany.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.PingHostMany;
  return proto.brokermanager.PingHostMany.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.PingHostMany} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.PingHostMany}
 */
proto.brokermanager.PingHostMany.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPort(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.PingHostMany.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.PingHostMany.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.PingHostMany} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.PingHostMany.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string host = 1;
 * @return {string}
 */
proto.brokermanager.PingHostMany.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.PingHostMany} returns this
 */
proto.brokermanager.PingHostMany.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 port = 2;
 * @return {number}
 */
proto.brokermanager.PingHostMany.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.PingHostMany} returns this
 */
proto.brokermanager.PingHostMany.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.AdminPingHostManyReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminPingHostManyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminPingHostManyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminPingHostManyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminPingHostManyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serversList: jspb.Message.toObjectList(msg.getServersList(),
    proto.brokermanager.PingHostMany.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminPingHostManyReq}
 */
proto.brokermanager.AdminPingHostManyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminPingHostManyReq;
  return proto.brokermanager.AdminPingHostManyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminPingHostManyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminPingHostManyReq}
 */
proto.brokermanager.AdminPingHostManyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.brokermanager.PingHostMany;
      reader.readMessage(value,proto.brokermanager.PingHostMany.deserializeBinaryFromReader);
      msg.addServers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminPingHostManyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminPingHostManyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminPingHostManyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminPingHostManyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.brokermanager.PingHostMany.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PingHostMany servers = 1;
 * @return {!Array<!proto.brokermanager.PingHostMany>}
 */
proto.brokermanager.AdminPingHostManyReq.prototype.getServersList = function() {
  return /** @type{!Array<!proto.brokermanager.PingHostMany>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.PingHostMany, 1));
};


/**
 * @param {!Array<!proto.brokermanager.PingHostMany>} value
 * @return {!proto.brokermanager.AdminPingHostManyReq} returns this
*/
proto.brokermanager.AdminPingHostManyReq.prototype.setServersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.brokermanager.PingHostMany=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.PingHostMany}
 */
proto.brokermanager.AdminPingHostManyReq.prototype.addServers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.brokermanager.PingHostMany, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.AdminPingHostManyReq} returns this
 */
proto.brokermanager.AdminPingHostManyReq.prototype.clearServersList = function() {
  return this.setServersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.AdminPingHostManyReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminPingHostManyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminPingHostManyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminPingHostManyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminPingHostManyReply.toObject = function(includeInstance, msg) {
  var f, obj = {
serverResponsesList: jspb.Message.toObjectList(msg.getServerResponsesList(),
    proto.brokermanager.PingHostReply.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminPingHostManyReply}
 */
proto.brokermanager.AdminPingHostManyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminPingHostManyReply;
  return proto.brokermanager.AdminPingHostManyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminPingHostManyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminPingHostManyReply}
 */
proto.brokermanager.AdminPingHostManyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.brokermanager.PingHostReply;
      reader.readMessage(value,proto.brokermanager.PingHostReply.deserializeBinaryFromReader);
      msg.addServerResponses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminPingHostManyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminPingHostManyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminPingHostManyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminPingHostManyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerResponsesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.brokermanager.PingHostReply.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PingHostReply server_responses = 1;
 * @return {!Array<!proto.brokermanager.PingHostReply>}
 */
proto.brokermanager.AdminPingHostManyReply.prototype.getServerResponsesList = function() {
  return /** @type{!Array<!proto.brokermanager.PingHostReply>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.PingHostReply, 1));
};


/**
 * @param {!Array<!proto.brokermanager.PingHostReply>} value
 * @return {!proto.brokermanager.AdminPingHostManyReply} returns this
*/
proto.brokermanager.AdminPingHostManyReply.prototype.setServerResponsesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.brokermanager.PingHostReply=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.PingHostReply}
 */
proto.brokermanager.AdminPingHostManyReply.prototype.addServerResponses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.brokermanager.PingHostReply, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.AdminPingHostManyReply} returns this
 */
proto.brokermanager.AdminPingHostManyReply.prototype.clearServerResponsesList = function() {
  return this.setServerResponsesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.IntGetBrokerInfoByNameReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.IntGetBrokerInfoByNameReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerName: jspb.Message.getFieldWithDefault(msg, 1, ""),
platform: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReq}
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.IntGetBrokerInfoByNameReq;
  return proto.brokermanager.IntGetBrokerInfoByNameReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.IntGetBrokerInfoByNameReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReq}
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.IntGetBrokerInfoByNameReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.IntGetBrokerInfoByNameReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string broker_name = 1;
 * @return {string}
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.prototype.getBrokerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReq} returns this
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.prototype.setBrokerName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string platform = 2;
 * @return {string}
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReq} returns this
 */
proto.brokermanager.IntGetBrokerInfoByNameReq.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.IntGetBrokerInfoByNameReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.IntGetBrokerInfoByNameReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
brokerName: jspb.Message.getFieldWithDefault(msg, 2, ""),
server: (f = msg.getServer()) && proto.brokermanager.Server.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReply}
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.IntGetBrokerInfoByNameReply;
  return proto.brokermanager.IntGetBrokerInfoByNameReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.IntGetBrokerInfoByNameReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReply}
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerName(value);
      break;
    case 3:
      var value = new proto.brokermanager.Server;
      reader.readMessage(value,proto.brokermanager.Server.deserializeBinaryFromReader);
      msg.setServer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.IntGetBrokerInfoByNameReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.IntGetBrokerInfoByNameReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrokerName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getServer();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.brokermanager.Server.serializeBinaryToWriter
    );
  }
};


/**
 * optional string broker_id = 1;
 * @return {string}
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReply} returns this
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string broker_name = 2;
 * @return {string}
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.getBrokerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReply} returns this
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.setBrokerName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Server server = 3;
 * @return {?proto.brokermanager.Server}
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.getServer = function() {
  return /** @type{?proto.brokermanager.Server} */ (
    jspb.Message.getWrapperField(this, proto.brokermanager.Server, 3));
};


/**
 * @param {?proto.brokermanager.Server|undefined} value
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReply} returns this
*/
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.setServer = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.IntGetBrokerInfoByNameReply} returns this
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.clearServer = function() {
  return this.setServer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.IntGetBrokerInfoByNameReply.prototype.hasServer = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.AdminGetServersInfoReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminGetServersInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminGetServersInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminGetServersInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminGetServersInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminGetServersInfoReq}
 */
proto.brokermanager.AdminGetServersInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminGetServersInfoReq;
  return proto.brokermanager.AdminGetServersInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminGetServersInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminGetServersInfoReq}
 */
proto.brokermanager.AdminGetServersInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addServerIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminGetServersInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminGetServersInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminGetServersInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminGetServersInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string server_ids = 1;
 * @return {!Array<string>}
 */
proto.brokermanager.AdminGetServersInfoReq.prototype.getServerIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.brokermanager.AdminGetServersInfoReq} returns this
 */
proto.brokermanager.AdminGetServersInfoReq.prototype.setServerIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.AdminGetServersInfoReq} returns this
 */
proto.brokermanager.AdminGetServersInfoReq.prototype.addServerIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.AdminGetServersInfoReq} returns this
 */
proto.brokermanager.AdminGetServersInfoReq.prototype.clearServerIdsList = function() {
  return this.setServerIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminGetServersInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminGetServersInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminGetServersInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminGetServersInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
serverInfoMap: (f = msg.getServerInfoMap()) ? f.toObject(includeInstance, proto.brokermanager.ServerWithBroker.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminGetServersInfoReply}
 */
proto.brokermanager.AdminGetServersInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminGetServersInfoReply;
  return proto.brokermanager.AdminGetServersInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminGetServersInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminGetServersInfoReply}
 */
proto.brokermanager.AdminGetServersInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getServerInfoMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.brokermanager.ServerWithBroker.deserializeBinaryFromReader, "", new proto.brokermanager.ServerWithBroker());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminGetServersInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminGetServersInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminGetServersInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminGetServersInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerInfoMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.brokermanager.ServerWithBroker.serializeBinaryToWriter);
  }
};


/**
 * map<string, ServerWithBroker> server_info = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.brokermanager.ServerWithBroker>}
 */
proto.brokermanager.AdminGetServersInfoReply.prototype.getServerInfoMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.brokermanager.ServerWithBroker>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.brokermanager.ServerWithBroker));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.brokermanager.AdminGetServersInfoReply} returns this
 */
proto.brokermanager.AdminGetServersInfoReply.prototype.clearServerInfoMap = function() {
  this.getServerInfoMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.ListBrokersReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.ListBrokersReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.ListBrokersReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ListBrokersReq.toObject = function(includeInstance, msg) {
  var f, obj = {
query: jspb.Message.getFieldWithDefault(msg, 1, ""),
platform: jspb.Message.getFieldWithDefault(msg, 2, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.ListBrokersReq}
 */
proto.brokermanager.ListBrokersReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.ListBrokersReq;
  return proto.brokermanager.ListBrokersReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.ListBrokersReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.ListBrokersReq}
 */
proto.brokermanager.ListBrokersReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.ListBrokersReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.ListBrokersReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.ListBrokersReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ListBrokersReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.brokermanager.ListBrokersReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ListBrokersReq} returns this
 */
proto.brokermanager.ListBrokersReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string platform = 2;
 * @return {string}
 */
proto.brokermanager.ListBrokersReq.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ListBrokersReq} returns this
 */
proto.brokermanager.ListBrokersReq.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string pagination_cursor = 3;
 * @return {string}
 */
proto.brokermanager.ListBrokersReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ListBrokersReq} returns this
 */
proto.brokermanager.ListBrokersReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.ListBrokerReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.ListBrokerReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.ListBrokerReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.ListBrokerReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ListBrokerReply.toObject = function(includeInstance, msg) {
  var f, obj = {
brokersList: jspb.Message.toObjectList(msg.getBrokersList(),
    proto.brokermanager.BrokerInfo.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
total: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.ListBrokerReply}
 */
proto.brokermanager.ListBrokerReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.ListBrokerReply;
  return proto.brokermanager.ListBrokerReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.ListBrokerReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.ListBrokerReply}
 */
proto.brokermanager.ListBrokerReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.brokermanager.BrokerInfo;
      reader.readMessage(value,proto.brokermanager.BrokerInfo.deserializeBinaryFromReader);
      msg.addBrokers(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.ListBrokerReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.ListBrokerReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.ListBrokerReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ListBrokerReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.brokermanager.BrokerInfo.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * repeated BrokerInfo brokers = 1;
 * @return {!Array<!proto.brokermanager.BrokerInfo>}
 */
proto.brokermanager.ListBrokerReply.prototype.getBrokersList = function() {
  return /** @type{!Array<!proto.brokermanager.BrokerInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.BrokerInfo, 1));
};


/**
 * @param {!Array<!proto.brokermanager.BrokerInfo>} value
 * @return {!proto.brokermanager.ListBrokerReply} returns this
*/
proto.brokermanager.ListBrokerReply.prototype.setBrokersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.brokermanager.BrokerInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.BrokerInfo}
 */
proto.brokermanager.ListBrokerReply.prototype.addBrokers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.brokermanager.BrokerInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.ListBrokerReply} returns this
 */
proto.brokermanager.ListBrokerReply.prototype.clearBrokersList = function() {
  return this.setBrokersList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.brokermanager.ListBrokerReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ListBrokerReply} returns this
 */
proto.brokermanager.ListBrokerReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 total = 3;
 * @return {number}
 */
proto.brokermanager.ListBrokerReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.ListBrokerReply} returns this
 */
proto.brokermanager.ListBrokerReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.BrokerInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.BrokerInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.BrokerInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.BrokerInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
connectionType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.BrokerInfo}
 */
proto.brokermanager.BrokerInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.BrokerInfo;
  return proto.brokermanager.BrokerInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.BrokerInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.BrokerInfo}
 */
proto.brokermanager.BrokerInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.brokermanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.BrokerInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.BrokerInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.BrokerInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.BrokerInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.brokermanager.BrokerInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.BrokerInfo} returns this
 */
proto.brokermanager.BrokerInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.brokermanager.BrokerInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.BrokerInfo} returns this
 */
proto.brokermanager.BrokerInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ConnectionType connection_type = 3;
 * @return {!proto.brokermanager.ConnectionType}
 */
proto.brokermanager.BrokerInfo.prototype.getConnectionType = function() {
  return /** @type {!proto.brokermanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.brokermanager.ConnectionType} value
 * @return {!proto.brokermanager.BrokerInfo} returns this
 */
proto.brokermanager.BrokerInfo.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.GetBrokerInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.GetBrokerInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.GetBrokerInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetBrokerInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.GetBrokerInfoReq}
 */
proto.brokermanager.GetBrokerInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.GetBrokerInfoReq;
  return proto.brokermanager.GetBrokerInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.GetBrokerInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.GetBrokerInfoReq}
 */
proto.brokermanager.GetBrokerInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.GetBrokerInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.GetBrokerInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.GetBrokerInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetBrokerInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.brokermanager.GetBrokerInfoReq.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.GetBrokerInfoReq} returns this
 */
proto.brokermanager.GetBrokerInfoReq.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.GetBrokerInfoReply.repeatedFields_ = [7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.GetBrokerInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.GetBrokerInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetBrokerInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
platform: jspb.Message.getFieldWithDefault(msg, 2, ""),
bio: (f = msg.getBio()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
email: (f = msg.getEmail()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
phone: (f = msg.getPhone()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
location: (f = msg.getLocation()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
realServersList: jspb.Message.toObjectList(msg.getRealServersList(),
    proto.brokermanager.Server.toObject, includeInstance),
demoServersList: jspb.Message.toObjectList(msg.getDemoServersList(),
    proto.brokermanager.Server.toObject, includeInstance),
partnerId: (f = msg.getPartnerId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
connectionType: jspb.Message.getFieldWithDefault(msg, 10, 0),
systemName: (f = msg.getSystemName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.GetBrokerInfoReply}
 */
proto.brokermanager.GetBrokerInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.GetBrokerInfoReply;
  return proto.brokermanager.GetBrokerInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.GetBrokerInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.GetBrokerInfoReply}
 */
proto.brokermanager.GetBrokerInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBio(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmail(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhone(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 7:
      var value = new proto.brokermanager.Server;
      reader.readMessage(value,proto.brokermanager.Server.deserializeBinaryFromReader);
      msg.addRealServers(value);
      break;
    case 8:
      var value = new proto.brokermanager.Server;
      reader.readMessage(value,proto.brokermanager.Server.deserializeBinaryFromReader);
      msg.addDemoServers(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setPartnerId(value);
      break;
    case 10:
      var value = /** @type {!proto.brokermanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSystemName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.GetBrokerInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.GetBrokerInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetBrokerInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBio();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPhone();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRealServersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.brokermanager.Server.serializeBinaryToWriter
    );
  }
  f = message.getDemoServersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.brokermanager.Server.serializeBinaryToWriter
    );
  }
  f = message.getPartnerId();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getSystemName();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string platform = 2;
 * @return {string}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue bio = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getBio = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
*/
proto.brokermanager.GetBrokerInfoReply.prototype.setBio = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.clearBio = function() {
  return this.setBio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.hasBio = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue email = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getEmail = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
*/
proto.brokermanager.GetBrokerInfoReply.prototype.setEmail = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.clearEmail = function() {
  return this.setEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue phone = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getPhone = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
*/
proto.brokermanager.GetBrokerInfoReply.prototype.setPhone = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.clearPhone = function() {
  return this.setPhone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.hasPhone = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue location = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getLocation = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
*/
proto.brokermanager.GetBrokerInfoReply.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated Server real_servers = 7;
 * @return {!Array<!proto.brokermanager.Server>}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getRealServersList = function() {
  return /** @type{!Array<!proto.brokermanager.Server>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.Server, 7));
};


/**
 * @param {!Array<!proto.brokermanager.Server>} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
*/
proto.brokermanager.GetBrokerInfoReply.prototype.setRealServersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.brokermanager.Server=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.Server}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.addRealServers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.brokermanager.Server, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.clearRealServersList = function() {
  return this.setRealServersList([]);
};


/**
 * repeated Server demo_servers = 8;
 * @return {!Array<!proto.brokermanager.Server>}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getDemoServersList = function() {
  return /** @type{!Array<!proto.brokermanager.Server>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.Server, 8));
};


/**
 * @param {!Array<!proto.brokermanager.Server>} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
*/
proto.brokermanager.GetBrokerInfoReply.prototype.setDemoServersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.brokermanager.Server=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.Server}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.addDemoServers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.brokermanager.Server, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.clearDemoServersList = function() {
  return this.setDemoServersList([]);
};


/**
 * optional google.protobuf.Int64Value partner_id = 9;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getPartnerId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 9));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
*/
proto.brokermanager.GetBrokerInfoReply.prototype.setPartnerId = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.clearPartnerId = function() {
  return this.setPartnerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.hasPartnerId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ConnectionType connection_type = 10;
 * @return {!proto.brokermanager.ConnectionType}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getConnectionType = function() {
  return /** @type {!proto.brokermanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.brokermanager.ConnectionType} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional google.protobuf.StringValue system_name = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.getSystemName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
*/
proto.brokermanager.GetBrokerInfoReply.prototype.setSystemName = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.GetBrokerInfoReply} returns this
 */
proto.brokermanager.GetBrokerInfoReply.prototype.clearSystemName = function() {
  return this.setSystemName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.GetBrokerInfoReply.prototype.hasSystemName = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.Server.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.Server.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.Server} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.Server.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
address: jspb.Message.getFieldWithDefault(msg, 3, ""),
port: jspb.Message.getFieldWithDefault(msg, 4, 0),
baseSymbol: (f = msg.getBaseSymbol()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
connectionType: jspb.Message.getFieldWithDefault(msg, 6, 0),
operatingMode: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.Server}
 */
proto.brokermanager.Server.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.Server;
  return proto.brokermanager.Server.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.Server} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.Server}
 */
proto.brokermanager.Server.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPort(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBaseSymbol(value);
      break;
    case 6:
      var value = /** @type {!proto.brokermanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    case 7:
      var value = /** @type {!proto.brokermanager.OperatingMode} */ (reader.readEnum());
      msg.setOperatingMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.Server.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.Server.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.Server} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.Server.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getBaseSymbol();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getOperatingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.brokermanager.Server.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.Server} returns this
 */
proto.brokermanager.Server.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.brokermanager.Server.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.Server} returns this
 */
proto.brokermanager.Server.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address = 3;
 * @return {string}
 */
proto.brokermanager.Server.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.Server} returns this
 */
proto.brokermanager.Server.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 port = 4;
 * @return {number}
 */
proto.brokermanager.Server.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.Server} returns this
 */
proto.brokermanager.Server.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue base_symbol = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.Server.prototype.getBaseSymbol = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.Server} returns this
*/
proto.brokermanager.Server.prototype.setBaseSymbol = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.Server} returns this
 */
proto.brokermanager.Server.prototype.clearBaseSymbol = function() {
  return this.setBaseSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.Server.prototype.hasBaseSymbol = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ConnectionType connection_type = 6;
 * @return {!proto.brokermanager.ConnectionType}
 */
proto.brokermanager.Server.prototype.getConnectionType = function() {
  return /** @type {!proto.brokermanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.brokermanager.ConnectionType} value
 * @return {!proto.brokermanager.Server} returns this
 */
proto.brokermanager.Server.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional OperatingMode operating_mode = 7;
 * @return {!proto.brokermanager.OperatingMode}
 */
proto.brokermanager.Server.prototype.getOperatingMode = function() {
  return /** @type {!proto.brokermanager.OperatingMode} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.brokermanager.OperatingMode} value
 * @return {!proto.brokermanager.Server} returns this
 */
proto.brokermanager.Server.prototype.setOperatingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.ServerWithBroker.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.ServerWithBroker.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.ServerWithBroker} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerWithBroker.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
address: jspb.Message.getFieldWithDefault(msg, 3, ""),
port: jspb.Message.getFieldWithDefault(msg, 4, 0),
brokerId: jspb.Message.getFieldWithDefault(msg, 5, ""),
brokerName: jspb.Message.getFieldWithDefault(msg, 6, ""),
platform: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.ServerWithBroker}
 */
proto.brokermanager.ServerWithBroker.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.ServerWithBroker;
  return proto.brokermanager.ServerWithBroker.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.ServerWithBroker} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.ServerWithBroker}
 */
proto.brokermanager.ServerWithBroker.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPort(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.ServerWithBroker.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.ServerWithBroker.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.ServerWithBroker} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerWithBroker.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBrokerName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.brokermanager.ServerWithBroker.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerWithBroker} returns this
 */
proto.brokermanager.ServerWithBroker.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.brokermanager.ServerWithBroker.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerWithBroker} returns this
 */
proto.brokermanager.ServerWithBroker.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address = 3;
 * @return {string}
 */
proto.brokermanager.ServerWithBroker.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerWithBroker} returns this
 */
proto.brokermanager.ServerWithBroker.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 port = 4;
 * @return {number}
 */
proto.brokermanager.ServerWithBroker.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.ServerWithBroker} returns this
 */
proto.brokermanager.ServerWithBroker.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string broker_id = 5;
 * @return {string}
 */
proto.brokermanager.ServerWithBroker.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerWithBroker} returns this
 */
proto.brokermanager.ServerWithBroker.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string broker_name = 6;
 * @return {string}
 */
proto.brokermanager.ServerWithBroker.prototype.getBrokerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerWithBroker} returns this
 */
proto.brokermanager.ServerWithBroker.prototype.setBrokerName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string platform = 7;
 * @return {string}
 */
proto.brokermanager.ServerWithBroker.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerWithBroker} returns this
 */
proto.brokermanager.ServerWithBroker.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AddBrokerReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AddBrokerReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AddBrokerReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AddBrokerReq.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
platform: jspb.Message.getFieldWithDefault(msg, 2, ""),
bio: (f = msg.getBio()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
email: (f = msg.getEmail()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
phone: (f = msg.getPhone()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
location: (f = msg.getLocation()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
partnerId: (f = msg.getPartnerId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
connectionType: jspb.Message.getFieldWithDefault(msg, 8, 0),
systemName: (f = msg.getSystemName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AddBrokerReq}
 */
proto.brokermanager.AddBrokerReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AddBrokerReq;
  return proto.brokermanager.AddBrokerReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AddBrokerReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AddBrokerReq}
 */
proto.brokermanager.AddBrokerReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBio(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmail(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhone(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setPartnerId(value);
      break;
    case 8:
      var value = /** @type {!proto.brokermanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSystemName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AddBrokerReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AddBrokerReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AddBrokerReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AddBrokerReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBio();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPhone();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPartnerId();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSystemName();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.brokermanager.AddBrokerReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AddBrokerReq} returns this
 */
proto.brokermanager.AddBrokerReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string platform = 2;
 * @return {string}
 */
proto.brokermanager.AddBrokerReq.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AddBrokerReq} returns this
 */
proto.brokermanager.AddBrokerReq.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue bio = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.AddBrokerReq.prototype.getBio = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.AddBrokerReq} returns this
*/
proto.brokermanager.AddBrokerReq.prototype.setBio = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AddBrokerReq} returns this
 */
proto.brokermanager.AddBrokerReq.prototype.clearBio = function() {
  return this.setBio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AddBrokerReq.prototype.hasBio = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue email = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.AddBrokerReq.prototype.getEmail = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.AddBrokerReq} returns this
*/
proto.brokermanager.AddBrokerReq.prototype.setEmail = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AddBrokerReq} returns this
 */
proto.brokermanager.AddBrokerReq.prototype.clearEmail = function() {
  return this.setEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AddBrokerReq.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue phone = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.AddBrokerReq.prototype.getPhone = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.AddBrokerReq} returns this
*/
proto.brokermanager.AddBrokerReq.prototype.setPhone = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AddBrokerReq} returns this
 */
proto.brokermanager.AddBrokerReq.prototype.clearPhone = function() {
  return this.setPhone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AddBrokerReq.prototype.hasPhone = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue location = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.AddBrokerReq.prototype.getLocation = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.AddBrokerReq} returns this
*/
proto.brokermanager.AddBrokerReq.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AddBrokerReq} returns this
 */
proto.brokermanager.AddBrokerReq.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AddBrokerReq.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Int64Value partner_id = 7;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.brokermanager.AddBrokerReq.prototype.getPartnerId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 7));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.brokermanager.AddBrokerReq} returns this
*/
proto.brokermanager.AddBrokerReq.prototype.setPartnerId = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AddBrokerReq} returns this
 */
proto.brokermanager.AddBrokerReq.prototype.clearPartnerId = function() {
  return this.setPartnerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AddBrokerReq.prototype.hasPartnerId = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ConnectionType connection_type = 8;
 * @return {!proto.brokermanager.ConnectionType}
 */
proto.brokermanager.AddBrokerReq.prototype.getConnectionType = function() {
  return /** @type {!proto.brokermanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.brokermanager.ConnectionType} value
 * @return {!proto.brokermanager.AddBrokerReq} returns this
 */
proto.brokermanager.AddBrokerReq.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional google.protobuf.StringValue system_name = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.AddBrokerReq.prototype.getSystemName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.AddBrokerReq} returns this
*/
proto.brokermanager.AddBrokerReq.prototype.setSystemName = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AddBrokerReq} returns this
 */
proto.brokermanager.AddBrokerReq.prototype.clearSystemName = function() {
  return this.setSystemName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AddBrokerReq.prototype.hasSystemName = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AddBrokerReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AddBrokerReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AddBrokerReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AddBrokerReply.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AddBrokerReply}
 */
proto.brokermanager.AddBrokerReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AddBrokerReply;
  return proto.brokermanager.AddBrokerReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AddBrokerReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AddBrokerReply}
 */
proto.brokermanager.AddBrokerReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AddBrokerReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AddBrokerReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AddBrokerReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AddBrokerReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string broker_id = 1;
 * @return {string}
 */
proto.brokermanager.AddBrokerReply.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AddBrokerReply} returns this
 */
proto.brokermanager.AddBrokerReply.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.UpdateBrokerReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.UpdateBrokerReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.UpdateBrokerReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.UpdateBrokerReq.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
bio: (f = msg.getBio()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
email: (f = msg.getEmail()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
phone: (f = msg.getPhone()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
location: (f = msg.getLocation()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
partnerId: (f = msg.getPartnerId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
systemName: (f = msg.getSystemName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.UpdateBrokerReq}
 */
proto.brokermanager.UpdateBrokerReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.UpdateBrokerReq;
  return proto.brokermanager.UpdateBrokerReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.UpdateBrokerReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.UpdateBrokerReq}
 */
proto.brokermanager.UpdateBrokerReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBio(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmail(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhone(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setPartnerId(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSystemName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.UpdateBrokerReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.UpdateBrokerReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.UpdateBrokerReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.UpdateBrokerReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBio();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPhone();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPartnerId();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getSystemName();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.brokermanager.UpdateBrokerReq.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
 */
proto.brokermanager.UpdateBrokerReq.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.brokermanager.UpdateBrokerReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
 */
proto.brokermanager.UpdateBrokerReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue bio = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.UpdateBrokerReq.prototype.getBio = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
*/
proto.brokermanager.UpdateBrokerReq.prototype.setBio = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
 */
proto.brokermanager.UpdateBrokerReq.prototype.clearBio = function() {
  return this.setBio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.UpdateBrokerReq.prototype.hasBio = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue email = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.UpdateBrokerReq.prototype.getEmail = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
*/
proto.brokermanager.UpdateBrokerReq.prototype.setEmail = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
 */
proto.brokermanager.UpdateBrokerReq.prototype.clearEmail = function() {
  return this.setEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.UpdateBrokerReq.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue phone = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.UpdateBrokerReq.prototype.getPhone = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
*/
proto.brokermanager.UpdateBrokerReq.prototype.setPhone = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
 */
proto.brokermanager.UpdateBrokerReq.prototype.clearPhone = function() {
  return this.setPhone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.UpdateBrokerReq.prototype.hasPhone = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue location = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.UpdateBrokerReq.prototype.getLocation = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
*/
proto.brokermanager.UpdateBrokerReq.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
 */
proto.brokermanager.UpdateBrokerReq.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.UpdateBrokerReq.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Int64Value partner_id = 7;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.brokermanager.UpdateBrokerReq.prototype.getPartnerId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 7));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
*/
proto.brokermanager.UpdateBrokerReq.prototype.setPartnerId = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
 */
proto.brokermanager.UpdateBrokerReq.prototype.clearPartnerId = function() {
  return this.setPartnerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.UpdateBrokerReq.prototype.hasPartnerId = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue system_name = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.UpdateBrokerReq.prototype.getSystemName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
*/
proto.brokermanager.UpdateBrokerReq.prototype.setSystemName = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.UpdateBrokerReq} returns this
 */
proto.brokermanager.UpdateBrokerReq.prototype.clearSystemName = function() {
  return this.setSystemName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.UpdateBrokerReq.prototype.hasSystemName = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.UpdateBrokerReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.UpdateBrokerReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.UpdateBrokerReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.UpdateBrokerReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.UpdateBrokerReply}
 */
proto.brokermanager.UpdateBrokerReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.UpdateBrokerReply;
  return proto.brokermanager.UpdateBrokerReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.UpdateBrokerReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.UpdateBrokerReply}
 */
proto.brokermanager.UpdateBrokerReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.UpdateBrokerReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.UpdateBrokerReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.UpdateBrokerReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.UpdateBrokerReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.DeleteBrokerReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.DeleteBrokerReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.DeleteBrokerReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.DeleteBrokerReq.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.DeleteBrokerReq}
 */
proto.brokermanager.DeleteBrokerReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.DeleteBrokerReq;
  return proto.brokermanager.DeleteBrokerReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.DeleteBrokerReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.DeleteBrokerReq}
 */
proto.brokermanager.DeleteBrokerReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.DeleteBrokerReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.DeleteBrokerReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.DeleteBrokerReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.DeleteBrokerReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string broker_id = 1;
 * @return {string}
 */
proto.brokermanager.DeleteBrokerReq.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.DeleteBrokerReq} returns this
 */
proto.brokermanager.DeleteBrokerReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.DeleteBrokerReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.DeleteBrokerReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.DeleteBrokerReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.DeleteBrokerReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.DeleteBrokerReply}
 */
proto.brokermanager.DeleteBrokerReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.DeleteBrokerReply;
  return proto.brokermanager.DeleteBrokerReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.DeleteBrokerReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.DeleteBrokerReply}
 */
proto.brokermanager.DeleteBrokerReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.DeleteBrokerReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.DeleteBrokerReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.DeleteBrokerReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.DeleteBrokerReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AddServerReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AddServerReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AddServerReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AddServerReq.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
address: jspb.Message.getFieldWithDefault(msg, 3, ""),
isDemo: (f = msg.getIsDemo()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
port: jspb.Message.getFieldWithDefault(msg, 5, 0),
baseSymbol: (f = msg.getBaseSymbol()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
connectionType: jspb.Message.getFieldWithDefault(msg, 7, 0),
operatingMode: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AddServerReq}
 */
proto.brokermanager.AddServerReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AddServerReq;
  return proto.brokermanager.AddServerReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AddServerReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AddServerReq}
 */
proto.brokermanager.AddServerReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsDemo(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPort(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBaseSymbol(value);
      break;
    case 7:
      var value = /** @type {!proto.brokermanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    case 8:
      var value = /** @type {!proto.brokermanager.OperatingMode} */ (reader.readEnum());
      msg.setOperatingMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AddServerReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AddServerReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AddServerReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AddServerReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsDemo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getBaseSymbol();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getOperatingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional string broker_id = 1;
 * @return {string}
 */
proto.brokermanager.AddServerReq.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AddServerReq} returns this
 */
proto.brokermanager.AddServerReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.brokermanager.AddServerReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AddServerReq} returns this
 */
proto.brokermanager.AddServerReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address = 3;
 * @return {string}
 */
proto.brokermanager.AddServerReq.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AddServerReq} returns this
 */
proto.brokermanager.AddServerReq.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.BoolValue is_demo = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.brokermanager.AddServerReq.prototype.getIsDemo = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.brokermanager.AddServerReq} returns this
*/
proto.brokermanager.AddServerReq.prototype.setIsDemo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AddServerReq} returns this
 */
proto.brokermanager.AddServerReq.prototype.clearIsDemo = function() {
  return this.setIsDemo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AddServerReq.prototype.hasIsDemo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint64 port = 5;
 * @return {number}
 */
proto.brokermanager.AddServerReq.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.AddServerReq} returns this
 */
proto.brokermanager.AddServerReq.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue base_symbol = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.AddServerReq.prototype.getBaseSymbol = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.AddServerReq} returns this
*/
proto.brokermanager.AddServerReq.prototype.setBaseSymbol = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AddServerReq} returns this
 */
proto.brokermanager.AddServerReq.prototype.clearBaseSymbol = function() {
  return this.setBaseSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AddServerReq.prototype.hasBaseSymbol = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ConnectionType connection_type = 7;
 * @return {!proto.brokermanager.ConnectionType}
 */
proto.brokermanager.AddServerReq.prototype.getConnectionType = function() {
  return /** @type {!proto.brokermanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.brokermanager.ConnectionType} value
 * @return {!proto.brokermanager.AddServerReq} returns this
 */
proto.brokermanager.AddServerReq.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional OperatingMode operating_mode = 8;
 * @return {!proto.brokermanager.OperatingMode}
 */
proto.brokermanager.AddServerReq.prototype.getOperatingMode = function() {
  return /** @type {!proto.brokermanager.OperatingMode} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.brokermanager.OperatingMode} value
 * @return {!proto.brokermanager.AddServerReq} returns this
 */
proto.brokermanager.AddServerReq.prototype.setOperatingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AddServerReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AddServerReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AddServerReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AddServerReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AddServerReply}
 */
proto.brokermanager.AddServerReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AddServerReply;
  return proto.brokermanager.AddServerReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AddServerReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AddServerReply}
 */
proto.brokermanager.AddServerReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AddServerReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AddServerReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AddServerReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AddServerReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminUpdateServerReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminUpdateServerReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminUpdateServerReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
address: jspb.Message.getFieldWithDefault(msg, 3, ""),
isDemo: (f = msg.getIsDemo()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
port: jspb.Message.getFieldWithDefault(msg, 5, 0),
baseSymbol: (f = msg.getBaseSymbol()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
operatingMode: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminUpdateServerReq}
 */
proto.brokermanager.AdminUpdateServerReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminUpdateServerReq;
  return proto.brokermanager.AdminUpdateServerReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminUpdateServerReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminUpdateServerReq}
 */
proto.brokermanager.AdminUpdateServerReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsDemo(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPort(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBaseSymbol(value);
      break;
    case 7:
      var value = /** @type {!proto.brokermanager.OperatingMode} */ (reader.readEnum());
      msg.setOperatingMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminUpdateServerReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminUpdateServerReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminUpdateServerReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsDemo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getBaseSymbol();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOperatingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string server_id = 1;
 * @return {string}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminUpdateServerReq} returns this
 */
proto.brokermanager.AdminUpdateServerReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminUpdateServerReq} returns this
 */
proto.brokermanager.AdminUpdateServerReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address = 3;
 * @return {string}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminUpdateServerReq} returns this
 */
proto.brokermanager.AdminUpdateServerReq.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.BoolValue is_demo = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.getIsDemo = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.brokermanager.AdminUpdateServerReq} returns this
*/
proto.brokermanager.AdminUpdateServerReq.prototype.setIsDemo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AdminUpdateServerReq} returns this
 */
proto.brokermanager.AdminUpdateServerReq.prototype.clearIsDemo = function() {
  return this.setIsDemo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.hasIsDemo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint64 port = 5;
 * @return {number}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.AdminUpdateServerReq} returns this
 */
proto.brokermanager.AdminUpdateServerReq.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue base_symbol = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.getBaseSymbol = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.AdminUpdateServerReq} returns this
*/
proto.brokermanager.AdminUpdateServerReq.prototype.setBaseSymbol = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AdminUpdateServerReq} returns this
 */
proto.brokermanager.AdminUpdateServerReq.prototype.clearBaseSymbol = function() {
  return this.setBaseSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.hasBaseSymbol = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional OperatingMode operating_mode = 7;
 * @return {!proto.brokermanager.OperatingMode}
 */
proto.brokermanager.AdminUpdateServerReq.prototype.getOperatingMode = function() {
  return /** @type {!proto.brokermanager.OperatingMode} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.brokermanager.OperatingMode} value
 * @return {!proto.brokermanager.AdminUpdateServerReq} returns this
 */
proto.brokermanager.AdminUpdateServerReq.prototype.setOperatingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminUpdateServerReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminUpdateServerReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminUpdateServerReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminUpdateServerReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminUpdateServerReply}
 */
proto.brokermanager.AdminUpdateServerReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminUpdateServerReply;
  return proto.brokermanager.AdminUpdateServerReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminUpdateServerReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminUpdateServerReply}
 */
proto.brokermanager.AdminUpdateServerReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminUpdateServerReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminUpdateServerReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminUpdateServerReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminUpdateServerReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.DeleteServerReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.DeleteServerReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.DeleteServerReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.DeleteServerReq.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.DeleteServerReq}
 */
proto.brokermanager.DeleteServerReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.DeleteServerReq;
  return proto.brokermanager.DeleteServerReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.DeleteServerReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.DeleteServerReq}
 */
proto.brokermanager.DeleteServerReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.DeleteServerReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.DeleteServerReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.DeleteServerReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.DeleteServerReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string broker_id = 1;
 * @return {string}
 */
proto.brokermanager.DeleteServerReq.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.DeleteServerReq} returns this
 */
proto.brokermanager.DeleteServerReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string server_id = 2;
 * @return {string}
 */
proto.brokermanager.DeleteServerReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.DeleteServerReq} returns this
 */
proto.brokermanager.DeleteServerReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.DeleteServerReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.DeleteServerReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.DeleteServerReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.DeleteServerReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.DeleteServerReply}
 */
proto.brokermanager.DeleteServerReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.DeleteServerReply;
  return proto.brokermanager.DeleteServerReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.DeleteServerReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.DeleteServerReply}
 */
proto.brokermanager.DeleteServerReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.DeleteServerReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.DeleteServerReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.DeleteServerReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.DeleteServerReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.GetServerInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.GetServerInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.GetServerInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetServerInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.GetServerInfoReq}
 */
proto.brokermanager.GetServerInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.GetServerInfoReq;
  return proto.brokermanager.GetServerInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.GetServerInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.GetServerInfoReq}
 */
proto.brokermanager.GetServerInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.GetServerInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.GetServerInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.GetServerInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetServerInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string broker_id = 1;
 * @return {string}
 */
proto.brokermanager.GetServerInfoReq.prototype.getBrokerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.GetServerInfoReq} returns this
 */
proto.brokermanager.GetServerInfoReq.prototype.setBrokerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string server_id = 2;
 * @return {string}
 */
proto.brokermanager.GetServerInfoReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.GetServerInfoReq} returns this
 */
proto.brokermanager.GetServerInfoReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.GetServerInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.GetServerInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.GetServerInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetServerInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
baseSymbol: (f = msg.getBaseSymbol()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
connectionType: jspb.Message.getFieldWithDefault(msg, 5, 0),
operatingMode: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.GetServerInfoReply}
 */
proto.brokermanager.GetServerInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.GetServerInfoReply;
  return proto.brokermanager.GetServerInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.GetServerInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.GetServerInfoReply}
 */
proto.brokermanager.GetServerInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBaseSymbol(value);
      break;
    case 5:
      var value = /** @type {!proto.brokermanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    case 6:
      var value = /** @type {!proto.brokermanager.OperatingMode} */ (reader.readEnum());
      msg.setOperatingMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.GetServerInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.GetServerInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.GetServerInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetServerInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getBaseSymbol();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getOperatingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.brokermanager.GetServerInfoReply.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.GetServerInfoReply} returns this
 */
proto.brokermanager.GetServerInfoReply.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.brokermanager.GetServerInfoReply.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.GetServerInfoReply} returns this
 */
proto.brokermanager.GetServerInfoReply.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_demo = 3;
 * @return {boolean}
 */
proto.brokermanager.GetServerInfoReply.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.brokermanager.GetServerInfoReply} returns this
 */
proto.brokermanager.GetServerInfoReply.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue base_symbol = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.GetServerInfoReply.prototype.getBaseSymbol = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.GetServerInfoReply} returns this
*/
proto.brokermanager.GetServerInfoReply.prototype.setBaseSymbol = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.GetServerInfoReply} returns this
 */
proto.brokermanager.GetServerInfoReply.prototype.clearBaseSymbol = function() {
  return this.setBaseSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.GetServerInfoReply.prototype.hasBaseSymbol = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ConnectionType connection_type = 5;
 * @return {!proto.brokermanager.ConnectionType}
 */
proto.brokermanager.GetServerInfoReply.prototype.getConnectionType = function() {
  return /** @type {!proto.brokermanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.brokermanager.ConnectionType} value
 * @return {!proto.brokermanager.GetServerInfoReply} returns this
 */
proto.brokermanager.GetServerInfoReply.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional OperatingMode operating_mode = 6;
 * @return {!proto.brokermanager.OperatingMode}
 */
proto.brokermanager.GetServerInfoReply.prototype.getOperatingMode = function() {
  return /** @type {!proto.brokermanager.OperatingMode} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.brokermanager.OperatingMode} value
 * @return {!proto.brokermanager.GetServerInfoReply} returns this
 */
proto.brokermanager.GetServerInfoReply.prototype.setOperatingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.SearchBrokerReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.SearchBrokerReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.SearchBrokerReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.SearchBrokerReq.toObject = function(includeInstance, msg) {
  var f, obj = {
company: jspb.Message.getFieldWithDefault(msg, 1, ""),
platform: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.SearchBrokerReq}
 */
proto.brokermanager.SearchBrokerReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.SearchBrokerReq;
  return proto.brokermanager.SearchBrokerReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.SearchBrokerReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.SearchBrokerReq}
 */
proto.brokermanager.SearchBrokerReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.SearchBrokerReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.SearchBrokerReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.SearchBrokerReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.SearchBrokerReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string company = 1;
 * @return {string}
 */
proto.brokermanager.SearchBrokerReq.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.SearchBrokerReq} returns this
 */
proto.brokermanager.SearchBrokerReq.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string platform = 2;
 * @return {string}
 */
proto.brokermanager.SearchBrokerReq.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.SearchBrokerReq} returns this
 */
proto.brokermanager.SearchBrokerReq.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.SearchBrokerRely.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.SearchBrokerRely.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.SearchBrokerRely.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.SearchBrokerRely} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.SearchBrokerRely.toObject = function(includeInstance, msg) {
  var f, obj = {
companiesList: jspb.Message.toObjectList(msg.getCompaniesList(),
    proto.brokermanager.Company.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.SearchBrokerRely}
 */
proto.brokermanager.SearchBrokerRely.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.SearchBrokerRely;
  return proto.brokermanager.SearchBrokerRely.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.SearchBrokerRely} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.SearchBrokerRely}
 */
proto.brokermanager.SearchBrokerRely.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.brokermanager.Company;
      reader.readMessage(value,proto.brokermanager.Company.deserializeBinaryFromReader);
      msg.addCompanies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.SearchBrokerRely.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.SearchBrokerRely.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.SearchBrokerRely} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.SearchBrokerRely.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompaniesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.brokermanager.Company.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Company companies = 1;
 * @return {!Array<!proto.brokermanager.Company>}
 */
proto.brokermanager.SearchBrokerRely.prototype.getCompaniesList = function() {
  return /** @type{!Array<!proto.brokermanager.Company>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.Company, 1));
};


/**
 * @param {!Array<!proto.brokermanager.Company>} value
 * @return {!proto.brokermanager.SearchBrokerRely} returns this
*/
proto.brokermanager.SearchBrokerRely.prototype.setCompaniesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.brokermanager.Company=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.Company}
 */
proto.brokermanager.SearchBrokerRely.prototype.addCompanies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.brokermanager.Company, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.SearchBrokerRely} returns this
 */
proto.brokermanager.SearchBrokerRely.prototype.clearCompaniesList = function() {
  return this.setCompaniesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.Company.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.Company.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.Company.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.Company} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.Company.toObject = function(includeInstance, msg) {
  var f, obj = {
company: jspb.Message.getFieldWithDefault(msg, 1, ""),
resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.brokermanager.ServerRes.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.Company}
 */
proto.brokermanager.Company.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.Company;
  return proto.brokermanager.Company.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.Company} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.Company}
 */
proto.brokermanager.Company.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 2:
      var value = new proto.brokermanager.ServerRes;
      reader.readMessage(value,proto.brokermanager.ServerRes.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.Company.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.Company.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.Company} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.Company.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.brokermanager.ServerRes.serializeBinaryToWriter
    );
  }
};


/**
 * optional string company = 1;
 * @return {string}
 */
proto.brokermanager.Company.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.Company} returns this
 */
proto.brokermanager.Company.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ServerRes results = 2;
 * @return {!Array<!proto.brokermanager.ServerRes>}
 */
proto.brokermanager.Company.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.brokermanager.ServerRes>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.ServerRes, 2));
};


/**
 * @param {!Array<!proto.brokermanager.ServerRes>} value
 * @return {!proto.brokermanager.Company} returns this
*/
proto.brokermanager.Company.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.brokermanager.ServerRes=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.ServerRes}
 */
proto.brokermanager.Company.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.brokermanager.ServerRes, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.Company} returns this
 */
proto.brokermanager.Company.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.ServerRes.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.ServerRes.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.ServerRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.ServerRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerRes.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
accessList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.ServerRes}
 */
proto.brokermanager.ServerRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.ServerRes;
  return proto.brokermanager.ServerRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.ServerRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.ServerRes}
 */
proto.brokermanager.ServerRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.ServerRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.ServerRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.ServerRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccessList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.brokermanager.ServerRes.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerRes} returns this
 */
proto.brokermanager.ServerRes.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string access = 2;
 * @return {!Array<string>}
 */
proto.brokermanager.ServerRes.prototype.getAccessList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.brokermanager.ServerRes} returns this
 */
proto.brokermanager.ServerRes.prototype.setAccessList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.ServerRes} returns this
 */
proto.brokermanager.ServerRes.prototype.addAccess = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.ServerRes} returns this
 */
proto.brokermanager.ServerRes.prototype.clearAccessList = function() {
  return this.setAccessList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.GetServerInfoManyReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.GetServerInfoManyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.GetServerInfoManyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.GetServerInfoManyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetServerInfoManyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serversList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.GetServerInfoManyReq}
 */
proto.brokermanager.GetServerInfoManyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.GetServerInfoManyReq;
  return proto.brokermanager.GetServerInfoManyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.GetServerInfoManyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.GetServerInfoManyReq}
 */
proto.brokermanager.GetServerInfoManyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addServers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.GetServerInfoManyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.GetServerInfoManyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.GetServerInfoManyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetServerInfoManyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string servers = 1;
 * @return {!Array<string>}
 */
proto.brokermanager.GetServerInfoManyReq.prototype.getServersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.brokermanager.GetServerInfoManyReq} returns this
 */
proto.brokermanager.GetServerInfoManyReq.prototype.setServersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.GetServerInfoManyReq} returns this
 */
proto.brokermanager.GetServerInfoManyReq.prototype.addServers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.GetServerInfoManyReq} returns this
 */
proto.brokermanager.GetServerInfoManyReq.prototype.clearServersList = function() {
  return this.setServersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.GetServerInfoManyReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.GetServerInfoManyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.GetServerInfoManyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.GetServerInfoManyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetServerInfoManyReply.toObject = function(includeInstance, msg) {
  var f, obj = {
serversList: jspb.Message.toObjectList(msg.getServersList(),
    proto.brokermanager.Server.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.GetServerInfoManyReply}
 */
proto.brokermanager.GetServerInfoManyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.GetServerInfoManyReply;
  return proto.brokermanager.GetServerInfoManyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.GetServerInfoManyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.GetServerInfoManyReply}
 */
proto.brokermanager.GetServerInfoManyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.brokermanager.Server;
      reader.readMessage(value,proto.brokermanager.Server.deserializeBinaryFromReader);
      msg.addServers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.GetServerInfoManyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.GetServerInfoManyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.GetServerInfoManyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.GetServerInfoManyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.brokermanager.Server.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Server servers = 1;
 * @return {!Array<!proto.brokermanager.Server>}
 */
proto.brokermanager.GetServerInfoManyReply.prototype.getServersList = function() {
  return /** @type{!Array<!proto.brokermanager.Server>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.Server, 1));
};


/**
 * @param {!Array<!proto.brokermanager.Server>} value
 * @return {!proto.brokermanager.GetServerInfoManyReply} returns this
*/
proto.brokermanager.GetServerInfoManyReply.prototype.setServersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.brokermanager.Server=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.Server}
 */
proto.brokermanager.GetServerInfoManyReply.prototype.addServers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.brokermanager.Server, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.GetServerInfoManyReply} returns this
 */
proto.brokermanager.GetServerInfoManyReply.prototype.clearServersList = function() {
  return this.setServersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.IntBrokerServerInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.IntBrokerServerInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.IntBrokerServerInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntBrokerServerInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.IntBrokerServerInfoReq}
 */
proto.brokermanager.IntBrokerServerInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.IntBrokerServerInfoReq;
  return proto.brokermanager.IntBrokerServerInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.IntBrokerServerInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.IntBrokerServerInfoReq}
 */
proto.brokermanager.IntBrokerServerInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.IntBrokerServerInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.IntBrokerServerInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.IntBrokerServerInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntBrokerServerInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string server_id = 1;
 * @return {string}
 */
proto.brokermanager.IntBrokerServerInfoReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReq} returns this
 */
proto.brokermanager.IntBrokerServerInfoReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.IntBrokerServerInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.IntBrokerServerInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntBrokerServerInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
address: jspb.Message.getFieldWithDefault(msg, 3, ""),
port: jspb.Message.getFieldWithDefault(msg, 4, 0),
tsId: (f = msg.getTsId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
baseSymbol: (f = msg.getBaseSymbol()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
connectionType: jspb.Message.getFieldWithDefault(msg, 7, 0),
operatingMode: jspb.Message.getFieldWithDefault(msg, 8, 0),
brokerName: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.IntBrokerServerInfoReply}
 */
proto.brokermanager.IntBrokerServerInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.IntBrokerServerInfoReply;
  return proto.brokermanager.IntBrokerServerInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.IntBrokerServerInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.IntBrokerServerInfoReply}
 */
proto.brokermanager.IntBrokerServerInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPort(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setTsId(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBaseSymbol(value);
      break;
    case 7:
      var value = /** @type {!proto.brokermanager.ConnectionType} */ (reader.readEnum());
      msg.setConnectionType(value);
      break;
    case 8:
      var value = /** @type {!proto.brokermanager.OperatingMode} */ (reader.readEnum());
      msg.setOperatingMode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.IntBrokerServerInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.IntBrokerServerInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntBrokerServerInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getTsId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getBaseSymbol();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getConnectionType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getOperatingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getBrokerName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address = 3;
 * @return {string}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 port = 4;
 * @return {number}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional google.protobuf.Int64Value ts_id = 5;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.getTsId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
*/
proto.brokermanager.IntBrokerServerInfoReply.prototype.setTsId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.clearTsId = function() {
  return this.setTsId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.hasTsId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue base_symbol = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.getBaseSymbol = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
*/
proto.brokermanager.IntBrokerServerInfoReply.prototype.setBaseSymbol = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.clearBaseSymbol = function() {
  return this.setBaseSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.hasBaseSymbol = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ConnectionType connection_type = 7;
 * @return {!proto.brokermanager.ConnectionType}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.getConnectionType = function() {
  return /** @type {!proto.brokermanager.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.brokermanager.ConnectionType} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional OperatingMode operating_mode = 8;
 * @return {!proto.brokermanager.OperatingMode}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.getOperatingMode = function() {
  return /** @type {!proto.brokermanager.OperatingMode} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.brokermanager.OperatingMode} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.setOperatingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string broker_name = 9;
 * @return {string}
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.getBrokerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.IntBrokerServerInfoReply} returns this
 */
proto.brokermanager.IntBrokerServerInfoReply.prototype.setBrokerName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.IntBrokerServersIPMapInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.IntBrokerServersIPMapInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
shouldFetchConnectionInfo: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReq}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.IntBrokerServersIPMapInfoReq;
  return proto.brokermanager.IntBrokerServersIPMapInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.IntBrokerServersIPMapInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReq}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addServerIds(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldFetchConnectionInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.IntBrokerServersIPMapInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.IntBrokerServersIPMapInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getShouldFetchConnectionInfo();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * repeated string server_ids = 1;
 * @return {!Array<string>}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.prototype.getServerIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReq} returns this
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.prototype.setServerIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReq} returns this
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.prototype.addServerIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReq} returns this
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.prototype.clearServerIdsList = function() {
  return this.setServerIdsList([]);
};


/**
 * optional bool should_fetch_connection_info = 3;
 * @return {boolean}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.prototype.getShouldFetchConnectionInfo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReq} returns this
 */
proto.brokermanager.IntBrokerServersIPMapInfoReq.prototype.setShouldFetchConnectionInfo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.IntBrokerServersIPMapInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.IntBrokerServersIPMapInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
serversList: jspb.Message.toObjectList(msg.getServersList(),
    proto.brokermanager.ServerInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReply}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.IntBrokerServersIPMapInfoReply;
  return proto.brokermanager.IntBrokerServersIPMapInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.IntBrokerServersIPMapInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReply}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.brokermanager.ServerInfo;
      reader.readMessage(value,proto.brokermanager.ServerInfo.deserializeBinaryFromReader);
      msg.addServers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.IntBrokerServersIPMapInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.IntBrokerServersIPMapInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.brokermanager.ServerInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ServerInfo servers = 1;
 * @return {!Array<!proto.brokermanager.ServerInfo>}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.prototype.getServersList = function() {
  return /** @type{!Array<!proto.brokermanager.ServerInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.ServerInfo, 1));
};


/**
 * @param {!Array<!proto.brokermanager.ServerInfo>} value
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReply} returns this
*/
proto.brokermanager.IntBrokerServersIPMapInfoReply.prototype.setServersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.brokermanager.ServerInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.ServerInfo}
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.prototype.addServers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.brokermanager.ServerInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.IntBrokerServersIPMapInfoReply} returns this
 */
proto.brokermanager.IntBrokerServersIPMapInfoReply.prototype.clearServersList = function() {
  return this.setServersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.ServerInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.ServerInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.ServerInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.ServerInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
serverIpsList: jspb.Message.toObjectList(msg.getServerIpsList(),
    proto.brokermanager.ServerIP.toObject, includeInstance),
baseSymbol: (f = msg.getBaseSymbol()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
connectionType: (f = msg.getConnectionType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.ServerInfo}
 */
proto.brokermanager.ServerInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.ServerInfo;
  return proto.brokermanager.ServerInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.ServerInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.ServerInfo}
 */
proto.brokermanager.ServerInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.brokermanager.ServerIP;
      reader.readMessage(value,proto.brokermanager.ServerIP.deserializeBinaryFromReader);
      msg.addServerIps(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBaseSymbol(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setConnectionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.ServerInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.ServerInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.ServerInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getServerIpsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.brokermanager.ServerIP.serializeBinaryToWriter
    );
  }
  f = message.getBaseSymbol();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getConnectionType();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.brokermanager.ServerInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerInfo} returns this
 */
proto.brokermanager.ServerInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.brokermanager.ServerInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerInfo} returns this
 */
proto.brokermanager.ServerInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ServerIP server_ips = 3;
 * @return {!Array<!proto.brokermanager.ServerIP>}
 */
proto.brokermanager.ServerInfo.prototype.getServerIpsList = function() {
  return /** @type{!Array<!proto.brokermanager.ServerIP>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.ServerIP, 3));
};


/**
 * @param {!Array<!proto.brokermanager.ServerIP>} value
 * @return {!proto.brokermanager.ServerInfo} returns this
*/
proto.brokermanager.ServerInfo.prototype.setServerIpsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.brokermanager.ServerIP=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.ServerIP}
 */
proto.brokermanager.ServerInfo.prototype.addServerIps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.brokermanager.ServerIP, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.ServerInfo} returns this
 */
proto.brokermanager.ServerInfo.prototype.clearServerIpsList = function() {
  return this.setServerIpsList([]);
};


/**
 * optional google.protobuf.StringValue base_symbol = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.ServerInfo.prototype.getBaseSymbol = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.ServerInfo} returns this
*/
proto.brokermanager.ServerInfo.prototype.setBaseSymbol = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.ServerInfo} returns this
 */
proto.brokermanager.ServerInfo.prototype.clearBaseSymbol = function() {
  return this.setBaseSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.ServerInfo.prototype.hasBaseSymbol = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue connection_type = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.ServerInfo.prototype.getConnectionType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.ServerInfo} returns this
*/
proto.brokermanager.ServerInfo.prototype.setConnectionType = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.ServerInfo} returns this
 */
proto.brokermanager.ServerInfo.prototype.clearConnectionType = function() {
  return this.setConnectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.ServerInfo.prototype.hasConnectionType = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminAddServerIPReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminAddServerIPReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminAddServerIPReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminAddServerIPReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
address: (f = msg.getAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
port: (f = msg.getPort()) && google_protobuf_wrappers_pb.UInt64Value.toObject(includeInstance, f),
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminAddServerIPReq}
 */
proto.brokermanager.AdminAddServerIPReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminAddServerIPReq;
  return proto.brokermanager.AdminAddServerIPReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminAddServerIPReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminAddServerIPReq}
 */
proto.brokermanager.AdminAddServerIPReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.UInt64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt64Value.deserializeBinaryFromReader);
      msg.setPort(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminAddServerIPReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminAddServerIPReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminAddServerIPReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminAddServerIPReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPort();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.UInt64Value.serializeBinaryToWriter
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string server_id = 1;
 * @return {string}
 */
proto.brokermanager.AdminAddServerIPReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminAddServerIPReq} returns this
 */
proto.brokermanager.AdminAddServerIPReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue address = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.brokermanager.AdminAddServerIPReq.prototype.getAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.brokermanager.AdminAddServerIPReq} returns this
*/
proto.brokermanager.AdminAddServerIPReq.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AdminAddServerIPReq} returns this
 */
proto.brokermanager.AdminAddServerIPReq.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AdminAddServerIPReq.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.UInt64Value port = 3;
 * @return {?proto.google.protobuf.UInt64Value}
 */
proto.brokermanager.AdminAddServerIPReq.prototype.getPort = function() {
  return /** @type{?proto.google.protobuf.UInt64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt64Value, 3));
};


/**
 * @param {?proto.google.protobuf.UInt64Value|undefined} value
 * @return {!proto.brokermanager.AdminAddServerIPReq} returns this
*/
proto.brokermanager.AdminAddServerIPReq.prototype.setPort = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.AdminAddServerIPReq} returns this
 */
proto.brokermanager.AdminAddServerIPReq.prototype.clearPort = function() {
  return this.setPort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.AdminAddServerIPReq.prototype.hasPort = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool is_demo = 4;
 * @return {boolean}
 */
proto.brokermanager.AdminAddServerIPReq.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.brokermanager.AdminAddServerIPReq} returns this
 */
proto.brokermanager.AdminAddServerIPReq.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminAddServerIPReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminAddServerIPReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminAddServerIPReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminAddServerIPReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminAddServerIPReply}
 */
proto.brokermanager.AdminAddServerIPReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminAddServerIPReply;
  return proto.brokermanager.AdminAddServerIPReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminAddServerIPReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminAddServerIPReply}
 */
proto.brokermanager.AdminAddServerIPReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminAddServerIPReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminAddServerIPReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminAddServerIPReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminAddServerIPReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.AdminReorderServerIPsReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminReorderServerIPsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminReorderServerIPsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminReorderServerIPsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminReorderServerIPsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
serverIpOrdersList: jspb.Message.toObjectList(msg.getServerIpOrdersList(),
    proto.brokermanager.ServerIPOrder.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminReorderServerIPsReq}
 */
proto.brokermanager.AdminReorderServerIPsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminReorderServerIPsReq;
  return proto.brokermanager.AdminReorderServerIPsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminReorderServerIPsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminReorderServerIPsReq}
 */
proto.brokermanager.AdminReorderServerIPsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 2:
      var value = new proto.brokermanager.ServerIPOrder;
      reader.readMessage(value,proto.brokermanager.ServerIPOrder.deserializeBinaryFromReader);
      msg.addServerIpOrders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminReorderServerIPsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminReorderServerIPsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminReorderServerIPsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminReorderServerIPsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServerIpOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.brokermanager.ServerIPOrder.serializeBinaryToWriter
    );
  }
};


/**
 * optional string server_id = 1;
 * @return {string}
 */
proto.brokermanager.AdminReorderServerIPsReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminReorderServerIPsReq} returns this
 */
proto.brokermanager.AdminReorderServerIPsReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ServerIPOrder server_ip_orders = 2;
 * @return {!Array<!proto.brokermanager.ServerIPOrder>}
 */
proto.brokermanager.AdminReorderServerIPsReq.prototype.getServerIpOrdersList = function() {
  return /** @type{!Array<!proto.brokermanager.ServerIPOrder>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.ServerIPOrder, 2));
};


/**
 * @param {!Array<!proto.brokermanager.ServerIPOrder>} value
 * @return {!proto.brokermanager.AdminReorderServerIPsReq} returns this
*/
proto.brokermanager.AdminReorderServerIPsReq.prototype.setServerIpOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.brokermanager.ServerIPOrder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.ServerIPOrder}
 */
proto.brokermanager.AdminReorderServerIPsReq.prototype.addServerIpOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.brokermanager.ServerIPOrder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.AdminReorderServerIPsReq} returns this
 */
proto.brokermanager.AdminReorderServerIPsReq.prototype.clearServerIpOrdersList = function() {
  return this.setServerIpOrdersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.ServerIPOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.ServerIPOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.ServerIPOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerIPOrder.toObject = function(includeInstance, msg) {
  var f, obj = {
serverIpId: jspb.Message.getFieldWithDefault(msg, 1, ""),
priority: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.ServerIPOrder}
 */
proto.brokermanager.ServerIPOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.ServerIPOrder;
  return proto.brokermanager.ServerIPOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.ServerIPOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.ServerIPOrder}
 */
proto.brokermanager.ServerIPOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerIpId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.ServerIPOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.ServerIPOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.ServerIPOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerIPOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerIpId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string server_ip_id = 1;
 * @return {string}
 */
proto.brokermanager.ServerIPOrder.prototype.getServerIpId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerIPOrder} returns this
 */
proto.brokermanager.ServerIPOrder.prototype.setServerIpId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 priority = 2;
 * @return {number}
 */
proto.brokermanager.ServerIPOrder.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.brokermanager.ServerIPOrder} returns this
 */
proto.brokermanager.ServerIPOrder.prototype.setPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminReorderServerIPsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminReorderServerIPsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminReorderServerIPsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminReorderServerIPsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminReorderServerIPsReply}
 */
proto.brokermanager.AdminReorderServerIPsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminReorderServerIPsReply;
  return proto.brokermanager.AdminReorderServerIPsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminReorderServerIPsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminReorderServerIPsReply}
 */
proto.brokermanager.AdminReorderServerIPsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminReorderServerIPsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminReorderServerIPsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminReorderServerIPsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminReorderServerIPsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminGetServerIPsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminGetServerIPsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminGetServerIPsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminGetServerIPsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminGetServerIPsReq}
 */
proto.brokermanager.AdminGetServerIPsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminGetServerIPsReq;
  return proto.brokermanager.AdminGetServerIPsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminGetServerIPsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminGetServerIPsReq}
 */
proto.brokermanager.AdminGetServerIPsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminGetServerIPsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminGetServerIPsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminGetServerIPsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminGetServerIPsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string server_id = 1;
 * @return {string}
 */
proto.brokermanager.AdminGetServerIPsReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminGetServerIPsReq} returns this
 */
proto.brokermanager.AdminGetServerIPsReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.brokermanager.AdminGetServerIPsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminGetServerIPsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminGetServerIPsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminGetServerIPsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminGetServerIPsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
serverIpsList: jspb.Message.toObjectList(msg.getServerIpsList(),
    proto.brokermanager.ServerIP.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminGetServerIPsReply}
 */
proto.brokermanager.AdminGetServerIPsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminGetServerIPsReply;
  return proto.brokermanager.AdminGetServerIPsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminGetServerIPsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminGetServerIPsReply}
 */
proto.brokermanager.AdminGetServerIPsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.brokermanager.ServerIP;
      reader.readMessage(value,proto.brokermanager.ServerIP.deserializeBinaryFromReader);
      msg.addServerIps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminGetServerIPsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminGetServerIPsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminGetServerIPsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminGetServerIPsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerIpsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.brokermanager.ServerIP.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ServerIP server_ips = 1;
 * @return {!Array<!proto.brokermanager.ServerIP>}
 */
proto.brokermanager.AdminGetServerIPsReply.prototype.getServerIpsList = function() {
  return /** @type{!Array<!proto.brokermanager.ServerIP>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.brokermanager.ServerIP, 1));
};


/**
 * @param {!Array<!proto.brokermanager.ServerIP>} value
 * @return {!proto.brokermanager.AdminGetServerIPsReply} returns this
*/
proto.brokermanager.AdminGetServerIPsReply.prototype.setServerIpsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.brokermanager.ServerIP=} opt_value
 * @param {number=} opt_index
 * @return {!proto.brokermanager.ServerIP}
 */
proto.brokermanager.AdminGetServerIPsReply.prototype.addServerIps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.brokermanager.ServerIP, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.brokermanager.AdminGetServerIPsReply} returns this
 */
proto.brokermanager.AdminGetServerIPsReply.prototype.clearServerIpsList = function() {
  return this.setServerIpsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.ServerIP.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.ServerIP.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.ServerIP} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerIP.toObject = function(includeInstance, msg) {
  var f, obj = {
serverIpId: jspb.Message.getFieldWithDefault(msg, 1, ""),
address: jspb.Message.getFieldWithDefault(msg, 2, ""),
port: (f = msg.getPort()) && google_protobuf_wrappers_pb.UInt64Value.toObject(includeInstance, f),
priority: (f = msg.getPriority()) && google_protobuf_wrappers_pb.UInt64Value.toObject(includeInstance, f),
name: jspb.Message.getFieldWithDefault(msg, 5, ""),
status: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.ServerIP}
 */
proto.brokermanager.ServerIP.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.ServerIP;
  return proto.brokermanager.ServerIP.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.ServerIP} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.ServerIP}
 */
proto.brokermanager.ServerIP.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerIpId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.UInt64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt64Value.deserializeBinaryFromReader);
      msg.setPort(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.UInt64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt64Value.deserializeBinaryFromReader);
      msg.setPriority(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.ServerIP.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.ServerIP.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.ServerIP} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.ServerIP.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerIpId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPort();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.UInt64Value.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.UInt64Value.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string server_ip_id = 1;
 * @return {string}
 */
proto.brokermanager.ServerIP.prototype.getServerIpId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerIP} returns this
 */
proto.brokermanager.ServerIP.prototype.setServerIpId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address = 2;
 * @return {string}
 */
proto.brokermanager.ServerIP.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerIP} returns this
 */
proto.brokermanager.ServerIP.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.UInt64Value port = 3;
 * @return {?proto.google.protobuf.UInt64Value}
 */
proto.brokermanager.ServerIP.prototype.getPort = function() {
  return /** @type{?proto.google.protobuf.UInt64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt64Value, 3));
};


/**
 * @param {?proto.google.protobuf.UInt64Value|undefined} value
 * @return {!proto.brokermanager.ServerIP} returns this
*/
proto.brokermanager.ServerIP.prototype.setPort = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.ServerIP} returns this
 */
proto.brokermanager.ServerIP.prototype.clearPort = function() {
  return this.setPort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.ServerIP.prototype.hasPort = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.UInt64Value priority = 4;
 * @return {?proto.google.protobuf.UInt64Value}
 */
proto.brokermanager.ServerIP.prototype.getPriority = function() {
  return /** @type{?proto.google.protobuf.UInt64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt64Value, 4));
};


/**
 * @param {?proto.google.protobuf.UInt64Value|undefined} value
 * @return {!proto.brokermanager.ServerIP} returns this
*/
proto.brokermanager.ServerIP.prototype.setPriority = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.brokermanager.ServerIP} returns this
 */
proto.brokermanager.ServerIP.prototype.clearPriority = function() {
  return this.setPriority(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.brokermanager.ServerIP.prototype.hasPriority = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.brokermanager.ServerIP.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerIP} returns this
 */
proto.brokermanager.ServerIP.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.brokermanager.ServerIP.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.ServerIP} returns this
 */
proto.brokermanager.ServerIP.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminDeleteServerIPReq.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminDeleteServerIPReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminDeleteServerIPReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminDeleteServerIPReq.toObject = function(includeInstance, msg) {
  var f, obj = {
serverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
serverIpId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminDeleteServerIPReq}
 */
proto.brokermanager.AdminDeleteServerIPReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminDeleteServerIPReq;
  return proto.brokermanager.AdminDeleteServerIPReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminDeleteServerIPReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminDeleteServerIPReq}
 */
proto.brokermanager.AdminDeleteServerIPReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerIpId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminDeleteServerIPReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminDeleteServerIPReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminDeleteServerIPReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminDeleteServerIPReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServerIpId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string server_id = 1;
 * @return {string}
 */
proto.brokermanager.AdminDeleteServerIPReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminDeleteServerIPReq} returns this
 */
proto.brokermanager.AdminDeleteServerIPReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string server_ip_id = 2;
 * @return {string}
 */
proto.brokermanager.AdminDeleteServerIPReq.prototype.getServerIpId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.brokermanager.AdminDeleteServerIPReq} returns this
 */
proto.brokermanager.AdminDeleteServerIPReq.prototype.setServerIpId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.brokermanager.AdminDeleteServerIPReply.prototype.toObject = function(opt_includeInstance) {
  return proto.brokermanager.AdminDeleteServerIPReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.brokermanager.AdminDeleteServerIPReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminDeleteServerIPReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.brokermanager.AdminDeleteServerIPReply}
 */
proto.brokermanager.AdminDeleteServerIPReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.brokermanager.AdminDeleteServerIPReply;
  return proto.brokermanager.AdminDeleteServerIPReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.brokermanager.AdminDeleteServerIPReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.brokermanager.AdminDeleteServerIPReply}
 */
proto.brokermanager.AdminDeleteServerIPReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.brokermanager.AdminDeleteServerIPReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.brokermanager.AdminDeleteServerIPReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.brokermanager.AdminDeleteServerIPReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.brokermanager.AdminDeleteServerIPReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.brokermanager.ConnectionType = {
  DEFAULT: 0,
  BACKUP: 1
};

/**
 * @enum {number}
 */
proto.brokermanager.OperatingMode = {
  BROKER: 0,
  PROP: 1
};

goog.object.extend(exports, proto.brokermanager);
